import { SensorType } from '../../types/sensor-type';

export class MobileSecuritySensorView {
  static getRequirements(dependencies: any): string {
    return `
        <div class="sensor-requirement" sensor-type="${SensorType.MOBILE_SECURITY}">
          <gz-title class="sensor-title">${dependencies.translateFn('Make sure the following requirements are met:')}
          </gz-title>
          <ul>
            <li>${dependencies.translateFn('An active {activeSecurityMobile}.', {
              activeSecurityMobile:
                '<gz-link type="underline" href="https://www.bitdefender.com/business/support/en/77209-322681-licensing.html"><span>' +
                dependencies.translateFn('Security for Mobile license ') +
                '</span></gz-link>',
            })}</li>
            <li>${dependencies.translateFn(
              'An active license that contains the eXtended Detection and Response (XDR) feature'
            )}</li>
            <li>${dependencies.translateFn('The Mobile Security console is {provisioningAndAccess}.', {
              provisioningAndAccess:
                '<gz-link type="underline" href="https://www.bitdefender.com/business/support/en/77209-322407-provisioning-and-access.html"><span>' +
                dependencies.translateFn('provisioned and active') +
                '</span></gz-link>',
            })}</li>
          </ul>
          <span>${dependencies.translateFn(
            'When all requirements are met, the Security for Mobile sensor integration automatically becomes active. You can view it in the Sensors Management grid.'
          )}</span>
        </div>
        `;
  }
}
